module.exports = __webpack_public_path__ + "static/media/image-gallery-1.84a64a4d.jpg";